// MIL-127 — app-lock PIN fallback for browsers where WebAuthn's platform
// authenticator isn't available (see biometricAuth.ts's isBiometricSupported).
// The PIN is never persisted in plaintext — only a SHA-256 hex digest is
// stored, matching the "device preference, not a security boundary" model
// documented in appLockStore.ts.
export const PIN_LENGTH = 4

export function isValidPin(pin: string): boolean {
  return new RegExp(`^\\d{${PIN_LENGTH}}$`).test(pin)
}

export async function hashPin(pin: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(pin))
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('')
}

export async function verifyPin(pin: string, hash: string): Promise<boolean> {
  return (await hashPin(pin)) === hash
}
